import { exportToExcel } from '../../../common/hook'
import {
    BusMemoFooterPDFCOl,
    busMemoPDFColumn,
    busMemoPDFFitlerColumn,
    cargoMemoFooterPDFCOl,
    cargoMemoPDFColumn,
    cargoMemoPDFFitlerColumn,
    cargoMemoPDFFitlerColumn1,
} from '../common/AcountingConstants'

export const pdfColsToExcelCols = (cols) =>
    (cols || [])
        .filter((col) => col?.dataKey !== undefined && col?.dataKey !== '')
        .map((col) => ({
            header: col.header,
            field: col.dataKey,
            textAlign: ['number', 'quantity', 'currency'].includes(col.xlCol?.dataType) ? 'right' : 'left',
        }))

const sectionTitleCols = (title) => [{ header: title, field: 'title' }]

const normalizeDetailRows = (rows, firstField) => {
    if (!rows?.length) {
        return [{ [firstField]: 'No Records', dataType: 'entry' }]
    }
    return rows.map((row) => {
        if (row.isNoData) {
            return { [firstField]: row.caption || 'No Records', dataType: 'entry' }
        }
        if (row.isTotalRow) {
            return { ...row, [firstField]: row.caption || row[firstField] || 'Total', dataType: 'total' }
        }
        return { ...row, dataType: 'entry' }
    })
}

const withRowType = (rows) =>
    (rows || []).map((row) => ({
        ...row,
        dataType: row.isTotalRow ? 'total' : (row.dataType || 'entry'),
    }))

const pushSection = (headersList, dataList, title, cols, rows) => {
    headersList.push(sectionTitleCols(title))
    dataList.push([])
    headersList.push(cols)
    dataList.push(normalizeDetailRows(rows, cols[0]?.field))
}

export const exportBusMemoExcel = ({ fileName, headerData, selfRows, onlineRows, busTotals }) => {
    const busCols = pdfColsToExcelCols(busMemoPDFColumn)
    const headersList = [pdfColsToExcelCols(busMemoPDFFitlerColumn)]
    const dataList = [[{ ...headerData, dataType: 'entry' }]]
    pushSection(headersList, dataList, 'Self Booking', busCols, selfRows)
    pushSection(headersList, dataList, 'Online Booking', busCols, onlineRows)
    headersList.push(pdfColsToExcelCols(BusMemoFooterPDFCOl))
    dataList.push(withRowType(busTotals))
    return exportToExcel({
        fileName,
        sheetName: 'Bus Memo',
        headersList,
        dataList,
    })
}

export const exportCargoMemoExcel = ({ fileName, headerData, luggageCols, cargoRows, cargoTotals }) => {
    const luggageExcelCols = pdfColsToExcelCols(luggageCols || cargoMemoPDFColumn)
    const headersList = [
        pdfColsToExcelCols(cargoMemoPDFFitlerColumn),
        pdfColsToExcelCols(cargoMemoPDFFitlerColumn1),
    ]
    const headerRow = [{ ...headerData, dataType: 'entry' }]
    const dataList = [headerRow, headerRow]
    pushSection(headersList, dataList, 'Luggage Booking', luggageExcelCols, cargoRows)
    headersList.push(pdfColsToExcelCols(cargoMemoFooterPDFCOl))
    dataList.push(withRowType(cargoTotals))
    return exportToExcel({
        fileName,
        sheetName: 'Cargo Memo',
        headersList,
        dataList,
    })
}

export const exportBusAndCargoMemoExcel = ({
    fileName,
    headerData,
    selfRows,
    onlineRows,
    busTotals,
    luggageCols,
    cargoRows,
    cargoTotals,
    combinedTotals,
}) => {
    const busCols = pdfColsToExcelCols(busMemoPDFColumn)
    const luggageExcelCols = pdfColsToExcelCols(luggageCols || cargoMemoPDFColumn)
    const headersList = [
        pdfColsToExcelCols(cargoMemoPDFFitlerColumn),
        pdfColsToExcelCols(cargoMemoPDFFitlerColumn1),
    ]
    const headerRow = [{ ...headerData, dataType: 'entry' }]
    const dataList = [headerRow, headerRow]
    pushSection(headersList, dataList, 'Self Booking', busCols, selfRows)
    pushSection(headersList, dataList, 'Online Booking', busCols, onlineRows)
    headersList.push(pdfColsToExcelCols(BusMemoFooterPDFCOl))
    dataList.push(withRowType(busTotals))
    pushSection(headersList, dataList, 'Luggage Booking', luggageExcelCols, cargoRows)
    headersList.push(pdfColsToExcelCols(cargoMemoFooterPDFCOl))
    dataList.push(withRowType(cargoTotals))
    headersList.push(pdfColsToExcelCols(cargoMemoFooterPDFCOl))
    dataList.push(withRowType(combinedTotals))
    return exportToExcel({
        fileName,
        sheetName: 'Bus And Cargo Memo',
        headersList,
        dataList,
    })
}
